import React from 'react'
import { ClientSubAreas } from './ClientSubAreas'
import { useReportContext } from '../../../../_context/ReportContext'

interface ClientAreasProps {
    selectedAreaIndex: number;
    onNextArea?: () => void;
    isLastArea?: boolean;
}

export const ClientAreas: React.FC<ClientAreasProps> = ({
    selectedAreaIndex,
    onNextArea,
    isLastArea
}) => {
    const { newReport } = useReportContext()


    return (
        <div style={{ animation: "auFadeIn 0.3s ease-out both" }}>
            <h3 style={{
                fontSize: "1.25rem",
                fontWeight: 700,
                color: "#0f1c34",
                marginBottom: "24px",
                paddingBottom: "12px",
                borderBottom: "2px solid #E5E7EB"
            }}>
                {newReport.Areas[selectedAreaIndex].Name}
            </h3>

            <div>
                <ClientSubAreas subAreas={newReport.Areas[selectedAreaIndex].SubAreas} selectedAreaIndex={selectedAreaIndex} />
            </div>

            {!isLastArea && (
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "40px", marginBottom: "20px", paddingTop: "32px", borderTop: "2px dashed #E5E7EB" }}>
                    <button
                        className="au-submit-btn hover-trigger"
                        onClick={() => {
                            window.scrollTo({ top: 0, behavior: "smooth" });
                            if (onNextArea) onNextArea();
                        }}
                        style={{
                            background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                            color: "#fff",
                            border: "none",
                            padding: "12px 24px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            boxShadow: "0 4px 12px rgba(16, 185, 129, 0.2)"
                        }}
                    >
                        Next Area →
                    </button>
                </div>
            )}
        </div>
    )
}

